import { useMemo } from 'react';

import { useMakes } from 'Stores/MakesStore/MakesStore';
import { useGetModelById } from 'Stores/ModelsStore/ModelsStore';
import { ALL_MODELS_BY_MAKE } from 'Utilities/makeModel/makeModel.helpers';

interface UseNormaliseMakeAndModelProps {
	make?: string;
	modelId: Nullable<number>;
}

interface UseNormaliseMakeAndModel {
	normalisedMake: string;
	normalisedModel: string;
}

export const useNormaliseMakeAndModel = ({
	make,
	modelId,
}: UseNormaliseMakeAndModelProps): UseNormaliseMakeAndModel => {
	const makes = useMakes();
	const getModelById = useGetModelById();

	const model = useMemo(() => {
		if (!modelId) return ALL_MODELS_BY_MAKE;
		return getModelById(modelId)?.name ?? ALL_MODELS_BY_MAKE;
	}, [getModelById, modelId]);

	const normalisedMake = makes?.find(({ name }) => make === name)?.slug || '';
	const normalisedModel = model;

	return { normalisedMake, normalisedModel };
};
